// Copyright (c) 2025. CYBERKOALA LLC.
//
// SPDX-License-Identifier: Proprietary License.
//
// Redistribution and use in source and binary forms, with or without
// modification, are restricted.

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import './globals.css';
import { App } from './app';
import './i18n/i18n';
import { IS_PUBLIC_ROUTE } from '@/public-routes.ts';
import { AppErrorBoundary } from '@/components/app-error-boundary.tsx';
import { initTracerError, initTracerErrorUploader } from '@apptracer/sdk';

initTracerError();

initTracerErrorUploader({
  appToken: 'uxYDpFng5tz6XMz9StrK0HYAA7t8jzFi7yV8HK1V9Av1',
  versionName: import.meta.env.VITE_TAG_VERSION ?? '1.0.0',
  environment: import.meta.env.DEV ? 'dev' : 'prod',
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </StrictMode>
);

const loadingScreen = document.getElementById('loading-screen');

if (loadingScreen) {
  if (IS_PUBLIC_ROUTE) {
    setTimeout(() => loadingScreen.remove(), 300);
  } else {
    setTimeout(() => loadingScreen.remove(), 2_500);
  }
}
